export default __webpack_public_path__ + "static/media/cross.643a3df5.svg";